import { z } from 'zod';
/**
 * Per-category, per-channel preference override. `in_app` is never a key
 * here — in-app delivery is unconditional (BR-68).
 */
export const CategoryChannelPreferenceSchema = z.object({
    email: z.boolean().optional(),
    push: z.boolean().optional(),
});
/**
 * NotificationPreference.categoryPreferences shape for manager identities:
 * Record<category, Partial<Record<'email'|'push', boolean>>>. Unset entries
 * default to enabled (BR-68).
 */
export const CategoryPreferencesSchema = z.record(z.string(), CategoryChannelPreferenceSchema);
//# sourceMappingURL=preferences.js.map